import { BusinessUnitShort } from 'src/@enums'
import { gaEvent, getBusinessUnitDescribed } from 'src/utils'

const baseEvent = (businessUnit: BusinessUnitShort) => ({
  event: 'ga-event',
  'event-category': `pagamentos-sellout:${getBusinessUnitDescribed(businessUnit)}`,
  'event-action': 'callback:login',
})

/**
 * [TARGET]: logar a RE
 *
 * [CONTEXTO]: o login é utilizado para permitir o acesso da RE
 *
 * [REGRAS]: n/a
 *
 * @param config - Objeto com dados do evento
 */
export const loginGAEvents = {
  success: (businessUnit: BusinessUnitShort) => {
    const successEvent = {
      ...baseEvent(businessUnit),
      'event-label': 'sucesso',
    }

    gaEvent(successEvent)
  },

  error: (businessUnit: BusinessUnitShort, error: string | number = 'generic') => {
    const errorEvent = {
      ...baseEvent(businessUnit),
      'event-label': `erro:${error}`,
    }

    gaEvent(errorEvent)
  },
}
